import {useMutation} from "@tanstack/react-query";

import {restoreMaterialFunctionMutationOptions} from "./restore-material-function.mutation-options";

export function useRestoreMaterialFunction() {
  return useMutation(restoreMaterialFunctionMutationOptions());
}
